import React from 'react';
import { PermissionGate } from './ProtectedRoute';

const KPICards = ({ 
  totalHires,
  hiresThisQuarter,
  currentQuarterLabel,
  avgTimeToHire, 
  avgNpsScore, 
  avgSalaryExpectation,
  onTotalHiresClick,
  onAvgTimeToHireClick,
  onAvgNpsScoreClick
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div 
        className="dashboard-card p-6 relative overflow-hidden slide-in-up cursor-pointer hover:shadow-lg transition-shadow duration-200" 
        style={{animationDelay: '0ms'}}
        onClick={onTotalHiresClick}
      >
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-indigo-500/10 to-transparent"></div>
        <div className="flex items-center">
          <div className="rounded-full p-3 mr-4 shadow-lg" style={{background: 'linear-gradient(135deg, #4841F0 0%, #3730c8 100%)'}}>
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div>
            <p className="text-gray-500 text-sm font-medium">Total Hires</p>
            <div className="flex items-baseline">
              <p className="text-3xl font-bold text-gray-800">{totalHires}</p>
              <span className="ml-2 text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-800">All time</span>
            </div>
            {hiresThisQuarter !== undefined && (
              <p className="text-xs font-semibold mt-1" style={{color: '#4841F0'}}>
                {hiresThisQuarter} this {currentQuarterLabel}
              </p>
            )}
          </div>
        </div>
      </div>
      
      <div 
        className="dashboard-card p-6 relative overflow-hidden slide-in-up cursor-pointer hover:shadow-lg transition-shadow duration-200" 
        style={{animationDelay: '100ms'}}
        onClick={onAvgTimeToHireClick}
      >
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-green-500/10 to-transparent"></div>
        <div className="flex items-center">
          <div className="rounded-full bg-gradient-to-br from-green-500 to-emerald-600 p-3 mr-4 shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-gray-500 text-sm font-medium">Avg. Time to Hire</p>
            <div className="flex items-baseline">
              <p className="text-3xl font-bold text-gray-800">{avgTimeToHire}</p>
              <span className="ml-2 text-xs font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-800">Days</span>
            </div>
            <p className="text-xs text-gray-400 mt-1">Click to view time-to-hire trends</p>
          </div>
        </div>
      </div>
      
      {/* NPS Score - Admin only since it shows TP ratings */}
      <PermissionGate requiredPermission="view_individual_client_nps">
        <div 
          className="dashboard-card p-6 relative overflow-hidden slide-in-up cursor-pointer hover:shadow-lg transition-shadow duration-200" 
          style={{animationDelay: '200ms'}}
          onClick={onAvgNpsScoreClick}
        >
          <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-purple-500/10 to-transparent"></div>
          <div className="flex items-center">
            <div className="rounded-full p-3 mr-4 shadow-lg" style={{background: 'linear-gradient(135deg, #6c63ff 0%, #4841F0 100%)'}}>
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div>
              <p className="text-gray-500 text-sm font-medium">Avg. NPS Score</p>
              <div className="flex items-baseline">
                <p className="text-3xl font-bold text-gray-800">{avgNpsScore}</p>
                <span className="ml-2 text-xs font-medium px-2 py-0.5 rounded-full bg-purple-100 text-purple-800">/ 10</span>
              </div>
              <p className="text-xs text-gray-400 mt-1">Click to view NPS details</p>
            </div>
          </div>
        </div>
      </PermissionGate>
      
      <div className="dashboard-card p-6 relative overflow-hidden slide-in-up" style={{animationDelay: '250ms'}}>
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-amber-500/10 to-transparent"></div>
        <div className="flex items-center">
          <div className="rounded-full bg-gradient-to-br from-amber-500 to-orange-600 p-3 mr-4 shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-gray-500 text-sm font-medium">Avg. Salary Expectation</p>
            <div className="flex items-baseline">
              <p className="text-3xl font-bold text-gray-800">€{avgSalaryExpectation.toLocaleString()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPICards;
